export const SGP_CMC_PRIVACY_STATEMENT = 'https://www.cmcinvest.sg/privacy';
export const SGP_CMC_TERMS_CONDITIONS = 'https://assets.cmcmarkets.com/legal-documents/en-sg/CMC_Invest_TAC.pdf';
export const SGP_CMC_RISK_DISCLOSURE = 'https://assets.cmcmarkets.com/legal-documents/en-sg/CMC_Invest_Risk_Disclosure.pdf';
export const SGP_CMC_COOKIE_POLICY = 'https://www.cmcinvest.sg/cookies';
export const SGP_CMC_LEGAL_DOCUMENTS = 'https://www.cmcmarkets.com/en-sg/legal-documents';
export const SGP_CMC_PLATFORM_SITE = 'https://cmcmarketsinvest.com/sg/login';
export const SGP_GOV_CHECK_YOUR_WORK_PASS = 'https://service2.mom.gov.sg/workpass/enquiry/prelanding';
export const SGP_CMC_CONTACT_US = 'https://www.cmcinvest.com/en-sg/contact-us';
export const SGP_CMC_IMPORTANT_INFO = 'https://www.cmcinvest.com/en-sg/important-information';
export const SGP_CMC_TERMS_AND_POLICIES = 'https://www.cmcinvest.com/en-sg/terms-and-policies';
